import { combineReducers } from 'redux';

import app from './app.reducer';
import assetViewer from './assetViewer.reducer';
import auth from './auth.reducer';
import cms from './cms.reducer';
import config from './config.reducer';
import modal from './modal.reducer';
import notification from './notification.reducer';
import pos from './pos.reducer';
import ppc from './ppc.reducer';
import settings from './settings.reducer';
import sidebar from './sidebar.reducer';
import users from './users.reducer';

const rootReducer = combineReducers({
	app,
	assetViewer,
	auth,
	cms,
	config,
	modal,
	notification,
	pos,
	ppc,
	settings,
	sidebar,
	users,
});

export default rootReducer;
